<script>
export default {
  name: 'Warning'
}
</script>

<template>
    <div class="warning_lender">
       {{$t('peringatan')}}
    </div>
</template>

<style scoped>
.warning_lender {
    background-color: #d32f2f;
    width: 100%;
    color: #f9f9f9;
    padding: 12px 12px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1002;
    text-align: center;
    line-height: 1.3;
    font-weight: 500;
}
</style>
